module.exports = __webpack_public_path__ + "img/down-button_03.dd05db4a.png";